jQuery(($) => {
    $.fn.getSelectedFilters = function () {
        var items   = $(this).find('.m-field__select'),
            filters = {};

        items.each(function () {
            var activeType = $(this).attr('name'),
                activeVal  = $(this).val();

            if (activeVal[0]){
                filters[activeType] = filters[activeType] || [];
                filters[activeType].push(activeVal);
            }
        });

        return filters;
    }


    $.fn.getPage = function () {
        var page = parseInt($('.o-job-feed__content').data('page')) || 1;

        if ($(this).hasClass('m-pagination__next-link')) {
            page++;
        } else if ($(this).hasClass('m-pagination__previous-link')) {
            page--;
        } else if ($(this).hasClass('m-pagination__number')) {
            page = parseInt($(this).text());
        }

        return page;
    };


    if ($('.o-job-feed')[0]) {
        function fetch_job_listings(page) {
            var activeFilters = $('.o-job-feed__form').getSelectedFilters();

            $('.o-job-feed__content').addClass('o-job-feed__content--loading');

            if (!page){
                var currentPage = $('.o-job-feed__content').data('page');
            } else {
                currentPage = page;
            }

            $.ajax({
                type: 'POST',
                url: AJAX.url,
                data: {
                    action: 'load_filtered_posts',
                    active_filters: activeFilters,
                    page: currentPage
                },
                dataType: 'json',
                beforeSend: function () {
                    AjaxRunning++;
                },
                success: function (result) {
                    if (result.data.feed) {
                        $('.o-job-feed').html(result.data.feed);
                        $('.o-job-feed').find('.o-job-feed__content').removeClass('o-job-feed__content--loading');
                    }

                    if (result.data.filters) {
                        $('.m-filter-dropdowns-block').replaceWith(result.data.filters);
                    }

                    if (result.data.newUrl) {
                        window.history.pushState({
                            feed: result.data.feed,
                            filters: result.data.filters,
                        }, {}, result.data.newUrl);
                    }

                    $('html,body').animate({
                        scrollTop: $("#job-listings").offset().top
                    });

                    $(window).trigger('ajax');
                },

                complete: function () {
                    AjaxRunning--;
                }
            });
        }

        if ($('.o-job-feed__form .a-select')[0]) {
            var AjaxRunning = 0;

            $(window).on('load ajax', function () {
                $('.o-job-feed__form .a-select').on('change', function(){
                    //prevent form submitting here
                    fetch_job_listings(1);
                });

                $('.js-clear-job-filters').click(function (e) {
                    e.preventDefault();

                    $('.o-job-feed__form .a-select').each(function(){
                        $(this).find('option:selected').prop("selected", false);
                    });

                    fetch_job_listings(1);
                });

                $('.m-pagination__page-link').click(function (e) {
                    e.preventDefault();

                    var page = $(this).getPage();

                    fetch_job_listings(page);
                });
            });
        }

        $(window).on('popstate', function (e) {
            if (e.originalEvent.state !== null) {
                if (e.originalEvent.state.feed) {
                    $('.o-job-feed').html(e.originalEvent.state.feed);
                }

                if (e.originalEvent.state.filters) {
                    $('.o-job-feed__form').replaceWith(e.originalEvent.state.filters);
                }
            }
        });
    }
});